var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "configured-layout",
    {
      attrs: {
        title: "Select Powertrain",
        breadcrumbs: _vm.breadcrumbs,
        "next-title": "Next Step | Color"
      },
      on: { next: _vm.onNext }
    },
    [_c("options-list", { attrs: { options: _vm.powertrainOptions } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }